var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "groupInfo",
    },
    [
      _vm.group
        ? [
            _c("div", { staticClass: "info" }, [
              _c(
                "div",
                { staticClass: "bottons" },
                [
                  _c("el-button", {
                    attrs: { icon: "el-icon-edit", size: "mini" },
                    on: { click: _vm.openUpdateDialog },
                  }),
                  _c("el-button", {
                    attrs: {
                      icon: "el-icon-delete",
                      size: "mini",
                      type: "danger",
                    },
                    on: {
                      click: function ($event) {
                        _vm.isShowingGroupDeleteDialog = true
                      },
                    },
                  }),
                ],
                1
              ),
              _c("h1", [_vm._v(_vm._s(_vm.group.name))]),
              _vm.group.description.length > 0
                ? _c("p", { staticClass: "note" }, [
                    _vm._v(_vm._s(_vm.group.description)),
                  ])
                : _vm._e(),
              _c(
                "p",
                { staticClass: "manager" },
                [
                  _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                    _vm._v(_vm._s(_vm.$t("Cuona.Group.manager_name"))),
                  ]),
                  _c("span", { staticClass: "manager" }, [
                    _vm._v(_vm._s(_vm.group.manager.name)),
                  ]),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "attached" },
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("Cuona.Group.title01"))),
                  _c("span", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.group.devices.length)),
                  ]),
                ]),
                _c("DevicesTable", {
                  attrs: {
                    devices: _vm.group.devices,
                    edit: true,
                    loading: false,
                  },
                  on: {
                    openDialog: function ($event) {
                      _vm.isShowingAddDevicesDialog = true
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "events" },
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("Cuona.Group.title07"))),
                  _c("span", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.group.events.length)),
                  ]),
                ]),
                _c("EventsTable", {
                  attrs: {
                    events: _vm.group.events,
                    edit: false,
                    isGroupHidden: true,
                    loading: false,
                    actions: _vm.actions,
                  },
                  on: {
                    openDialog: function ($event) {
                      _vm.isShowingAddEventsDialog = true
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Cuona.Group.title05"),
                  width: "65%",
                  top: "8vh",
                  visible: _vm.isShowingGroupUpdateDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowingGroupUpdateDialog = $event
                  },
                  open: _vm.openedUpdateDialog,
                  closed: _vm.closedDialog,
                },
              },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    ref: "updateDialogForm",
                    staticClass: "form",
                    attrs: {
                      "label-position": "left",
                      rules: _vm.rules,
                      "label-width": "120px",
                      model: _vm.updateDialogForm,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Cuona.Group.name"),
                          prop: "name",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.updateDialogForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.updateDialogForm, "name", $$v)
                            },
                            expression: "updateDialogForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Cuona.Group.manager"),
                          prop: "managerId",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: _vm.$t("Cuona.Group.choice"),
                            },
                            model: {
                              value: _vm.updateDialogForm.managerId,
                              callback: function ($$v) {
                                _vm.$set(_vm.updateDialogForm, "managerId", $$v)
                              },
                              expression: "updateDialogForm.managerId",
                            },
                          },
                          _vm._l(
                            _vm.ownerAndManagers,
                            function (manager, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: manager.name,
                                  value: manager.id,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Cuona.Group.note") } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 3 },
                          model: {
                            value: _vm.updateDialogForm.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.updateDialogForm, "description", $$v)
                            },
                            expression: "updateDialogForm.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "CUONA" } }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "groupDeviceTable",
                              staticClass: "group",
                              attrs: {
                                data: _vm.devices,
                                "cell-class-name": "el-table-cell",
                                "row-class-name": "el-table-row",
                                "max-height": "300",
                              },
                              on: {
                                "row-click": _vm.toggleGroupedDevice,
                                "selection-change": _vm.setSelectedDevices,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "35" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "name",
                                  label: _vm.$t("Cuona.Group.show_name"),
                                  sortable: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          _c("img", {
                                            staticClass: "device-image",
                                            attrs: {
                                              src: _vm.getCuonaImage(props.row),
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(props.row.name)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1721781923
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  width: "180px",
                                  prop: "nfc_uid",
                                  label: _vm.$t("Cuona.Group.nfc_uid"),
                                  sortable: "",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "groups",
                                  label: _vm.$t("Cuona.Event.group"),
                                  sortable: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          _vm._l(
                                            props.row.groups,
                                            function (group) {
                                              return [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    staticClass: "group",
                                                    attrs: { size: "mini" },
                                                  },
                                                  [_vm._v(_vm._s(group.name))]
                                                ),
                                              ]
                                            }
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1346372346
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  width: "110px",
                                  prop: "device_type",
                                  label: _vm.$t("Cuona.Group.type"),
                                  formatter: _vm.typeFormatter,
                                  sortable: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.closeDialog },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isLoading },
                        on: { click: _vm.updateGroup },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.change")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Cuona.Group.title06", {
                    group_name: _vm.group.name,
                  }),
                  visible: _vm.isShowingGroupDeleteDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowingGroupDeleteDialog = $event
                  },
                },
              },
              [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.nl2br(_vm.$t("Cuona.Group.description01"))
                    ),
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          click: function ($event) {
                            _vm.isShowingGroupDeleteDialog = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", disabled: _vm.isLoading },
                        on: { click: _vm.deleteGroup },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.delete")))]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Cuona.Device.set_device"),
                  width: "65%",
                  top: "8vh",
                  visible: _vm.isShowingAddDevicesDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowingAddDevicesDialog = $event
                  },
                  closed: _vm.closedAddDevicesDialog,
                },
              },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    ref: "addDevicesDialogForm",
                    staticClass: "form",
                    attrs: {
                      "label-position": "left",
                      "label-width": "120px",
                      model: _vm.updateDialogForm,
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "addDevicesTable",
                            staticClass: "group",
                            attrs: {
                              data: _vm.devices,
                              "cell-class-name": "el-table-cell",
                              "row-class-name": "el-table-row",
                              "max-height": "300",
                            },
                            on: {
                              "row-click": _vm.toggleAddDevices,
                              "selection-change": _vm.setSelectedDevices,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "35" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("Cuona.Group.show_name"),
                                sortable: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("img", {
                                          staticClass: "device-image",
                                          attrs: {
                                            src: _vm.getCuonaImage(props.row),
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(props.row.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1721781923
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                width: "180px",
                                prop: "nfc_uid",
                                label: _vm.$t("Cuona.Group.nfc_uid"),
                                sortable: "",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "groups",
                                label: _vm.$t("Cuona.Event.group"),
                                sortable: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _vm._l(
                                          props.row.groups,
                                          function (group) {
                                            return [
                                              _c(
                                                "el-tag",
                                                {
                                                  staticClass: "group",
                                                  attrs: { size: "mini" },
                                                },
                                                [_vm._v(_vm._s(group.name))]
                                              ),
                                            ]
                                          }
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1346372346
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                width: "110px",
                                prop: "device_type",
                                label: _vm.$t("Cuona.Group.type"),
                                formatter: _vm.typeFormatter,
                                sortable: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          click: function ($event) {
                            _vm.isShowingAddDevicesDialog = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isLoading },
                        on: { click: _vm.addDevices },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.change")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Cuona.Event.set_event"),
                  width: "65%",
                  top: "8vh",
                  visible: _vm.isShowingAddEventsDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowingAddEventsDialog = $event
                  },
                  closed: _vm.closedAddEventsDialog,
                },
              },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    ref: "addEventsDialogForm",
                    staticClass: "form",
                    attrs: { "label-position": "left", "label-width": "120px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "groupEventTable",
                            staticClass: "group",
                            attrs: {
                              data: _vm.events,
                              "cell-class-name": "el-table-cell",
                              "row-class-name": "el-table-row",
                              "max-height": "300",
                            },
                            on: {
                              "row-click": _vm.toggleGroupedEvent,
                              "selection-change": _vm.setSelectedEvents,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "empty",
                                attrs: { slot: "empty" },
                                slot: "empty",
                              },
                              [
                                _c("img", { attrs: { src: _vm.images.empty } }),
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.nl2br(
                                        _vm.$t("Cuona.Event.description01")
                                      )
                                    ),
                                  },
                                }),
                              ]
                            ),
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "35" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("Cuona.Event.name"),
                                sortable: "",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Cuona.Event.action"),
                                sortable: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.showActions(
                                              props.row.action_type
                                            )
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                429386667
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "groups",
                                label: _vm.$t("Cuona.Event.group"),
                                sortable: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _vm._l(
                                          props.row.groups,
                                          function (group) {
                                            return [
                                              _c(
                                                "el-tag",
                                                {
                                                  staticClass: "group",
                                                  attrs: { size: "mini" },
                                                },
                                                [_vm._v(_vm._s(group.name))]
                                              ),
                                            ]
                                          }
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1346372346
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "description",
                                label: _vm.$t("Cuona.Event.note"),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          click: function ($event) {
                            _vm.isShowingAddEventsDialog = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isLoading },
                        on: { click: _vm.addEvents },
                      },
                      [_vm._v(_vm._s(_vm.$t("Cuona.Group.change")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }